// extracted by css-extract-rspack-plugin
export default {"cls1":"UserAvatar-cls1_C6Z","cls2":"UserAvatar-cls2_NlM UserAvatar-cls1_C6Z"};